module.exports = __webpack_public_path__ + "img/gebackenebananegerade.42405b7c.jpg";